import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_BFF_WEB_URL } from "utilities/Constant";

export interface FeatureFlag {
  cameraEnabled: boolean;
  newHeaderEnabled: boolean;
  insuranceAdEnabled: boolean;
  insurancePurchaseBannerEnabled: boolean;
  prStateEnabled: boolean;
  complianceServiceEnabled: boolean;
  allowedUploadFileTypes: string;
  preApprovalLetterEnabled: boolean;
  insuranceQuickNewTabEnabled: boolean;
  insuranceAdForSubPropAddressEnabled: boolean;
  uQualSelfReferralAdLogicEnabled: boolean;
  newResetPasswordPageEnabled: boolean;
  borrowerProfilePasswordResetEnabled: boolean;
  updatePhoneNumberEnabled: boolean;
  splitConsentEnabled: boolean;
  dashboardForAll: boolean;
  ttdCodeSnippetEnabled: boolean;
  npsSurveyEnabled: boolean;
  npsSurveyCdEnabled: boolean;
  npsSurveyRetailEnabled: boolean;
  nscbApplicantRangeEnabled: boolean;
  dashboardV2Enabled: boolean;
  loanDetailsEnabled: boolean;
  exitSurveyEnabled: boolean;
  userGuidance: boolean;
  redesignAnnouncementEnabled: boolean;
  showNhDealApplicationIdEnabled : boolean;
  encompassApplicationDocumentUploadEnabled: boolean;
  nativeAppPromoEnabled: boolean;
  enhancedConditionsSessionHeldUnderReviewEnabled?: boolean;
  enhancedConditionsDocumentUploadEmailSuppressionEnabled?: boolean;
  preferredLanguageEnabled?: boolean;
  myLoansV2Enabled: boolean;
  loanCentricSidebarNavEnabled?: boolean;
  dualLosPortfolioEnabled?: boolean;
  errorTaskValidationEnabled?: boolean;
  otpDeliveryMethodSelectionEnabled?: boolean;
}

export const featureFlagApi = createApi({
  reducerPath: "featureFlagApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_BFF_WEB_URL }),
  endpoints: (build) => ({
    getFeatureFlags: build.query<FeatureFlag, void>({
      query: () => `/bff/feature-flags`,
    }),
  }),
});

export const { useGetFeatureFlagsQuery } = featureFlagApi;
